export default __webpack_public_path__ + "static/media/audio-call.05d2b303.svg";